<!-- desktop view -->
<owl-carousel-o [options]="carouselOptions" class="d-md-block d-none">
  @for (row of dashboardTilesData; track row.value; let i = $index) {
    <ng-template carouselSlide [id]="i.toString()" class="owl-drag">
      <div class="user-col vt-border rounded-10 py-3 px-3">
        <div class="d-flex justify-content-between gap-2">
          <h6 class="font-fraunces fw-semibold heading fs-6">{{row.label}}</h6>
          <i class="icon-multiple-user fs-3 rounded-10 p-2"></i>
        </div>
        <p class="font-dm count text-dark-green font-14 fw-semibold">{{row.value}}</p>
      </div>
    </ng-template>
  }
</owl-carousel-o>

<!-- mobile view -->
<div class="user-col vt-border rounded-10 py-2 ps-2 pe-4 mb-3 d-md-none d-block" *ngFor="let row of dashboardTilesData">
  <div class="d-flex justify-content-between gap-2">
    <h6 class="font-fraunces fw-semibold heading fs-6">{{row.label}}</h6>
    <i class="icon-multiple-user fs-3 rounded-10 p-2"></i>
  </div>
  <p class="font-dm count text-dark-green font-14 fw-semibold">{{row.value}}</p>
</div>

<members></members>

